
import { Component, ChangeDetectionStrategy, ViewEncapsulation, HostListener, OnDestroy, AfterViewInit, ElementRef, Output, EventEmitter, ChangeDetectorRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AttachmentsComponent } from '@workbuddy/ui/components/attachments';
import { AccordionComponent, AccordionGroupComponent } from '@workbuddy/ui/components/accordion';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { AttachmentComponent } from '@workbuddy/ui/components/attachment';
import { ActiveService } from '@workbuddy/ui/services';
import { ActivityEntityName, Attachment } from '@jms/model';
import { EmptyMessageComponent } from '@jms/ui/ui.empty.message';
import { ViewEntity } from '@workbuddy/ui/blocks/module.header';
import { FilesContext } from '../../model';

export interface FileGroup {
    title: string;
    type: ActivityEntityName;
    hideTags: false;
    attachments: Attachment[];
}


@Component({
    selector: 'file-list',
    templateUrl: 'file.list.component.html',
    styleUrls: ['file.list.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        AccordionComponent,
        AccordionGroupComponent,
        AttachmentsComponent,
        CdkAccordionModule,
        EmptyMessageComponent
    ]
})
export class FileListComponent implements AfterViewInit, OnDestroy {

    @Input() public groups: FileGroup[];
    @Input() public entity: ActivityEntityName;
    @Input() public view: ViewEntity;
    @Input() public context: FilesContext;

    @Output() public selectionChanged = new EventEmitter<Attachment[]>();
    @Output() public activeChanged = new EventEmitter<Attachment>();
    @Output() public itemExpand = new EventEmitter<Attachment>();
    @Output() public itemUpdated = new EventEmitter<Attachment>();


    @Output() public addFile = new EventEmitter<ActivityEntityName>();

    constructor(
        private cdr: ChangeDetectorRef,
        private element: ElementRef<any>,
        private activeService: ActiveService<AttachmentComponent>,
    ) { }

    ngAfterViewInit(): void {
        this.element.nativeElement.focus();
    }

    @HostListener('keydown', ['$event'])
    onKeydown(event: KeyboardEvent) {

        const keyManager = this.activeService.keyManager;

        keyManager.onKeydown(event);
        const afterItem = keyManager?.activeItem;

        if (event.key === "Enter") {
            console.log('Select this guy', keyManager?.activeItem?.attachment);
            afterItem.activate();
        }

        if (event.key === 'Escape') {
            afterItem?.deactivate();
        }

        // if (event.key === 'Left') {
        //     console.log('Select the previous guy', keyManager?.activeItem?.attachment);
        //     keyManager.setPreviousItemActive();
        //     event.preventDefault();

        // }

        // if (event.key === 'Right') {
        //     console.log('Select the previous guy', keyManager?.activeItem?.attachment);
        //     keyManager.setNextItemActive();
        //     event.preventDefault();

        // }

        if (event.code === 'Space' && keyManager.activeItem) {
            event.preventDefault();

            afterItem.toggleSelection();
        }
    }

    @HostListener('focus', ['$event'])
    onFocused(event: FocusEvent) {
        console.log('focused', event);
        this.activeService.keyManager.setFirstItemActive();
    }

    ngOnDestroy(): void {
        //  this.keyManager.destroy();
    }

    protected onItemUpdated(attachment: Attachment): void {
        this.itemUpdated?.emit(attachment);
    }
}